import React from 'react';
import { Search, Filter, X } from 'lucide-react';

export default function PageHeader({
  title,
  subtitle,
  children,
  activePageTab,
  searchTerm,
  onSearchChange,
  hasFiltersApplied,
  onClearFilters,
  showTableFilters,
  onToggleFilters,
  onEditPrompts,
  placeholder = 'Search tracking # or company...',
}) {
  const hasTableControls = Boolean(activePageTab);

  return (
    <div className="topbar">
      <div className="topbar-left">
        {title ? <div className="topbar-title">{title}</div> : null}
        {subtitle ? <div className="topbar-sub">{subtitle}</div> : null}
      </div>
      <div className="topbar-right">
        {children}

        {hasTableControls && activePageTab === 'Insights' && (
          <div className="filters-bar page-header-filters">
            {hasFiltersApplied && (
              <button type="button" className="btn btn-sm btn-clear-filters" onClick={onClearFilters}>
                <X size={14} className="btn-clear-filters-icon" />
                <span>Clear Filters</span>
              </button>
            )}
            <div className="filter-btn-wrap">
              <button
                type="button"
                className={`btn btn-sm ${showTableFilters ? 'btn-primary' : ''} btn-filters`}
                onClick={onToggleFilters}
              >
                <Filter size={14} />
                <span>Filters</span>
                {hasFiltersApplied && (
                  <span
                    className="btn-filters-dot"
                    style={{ background: showTableFilters ? '#fff' : 'var(--c-black)' }}
                  />
                )}
              </button>
            </div>
          </div>
        )}

        {hasTableControls && activePageTab === 'Table' && (
          <div className="filters-bar page-header-filters">
            <div className="search-wrap">
              <Search className="search-icon" size={14} />
              <input
                className="search-input"
                type="text"
                placeholder={placeholder}
                value={searchTerm}
                onChange={onSearchChange}
              />
            </div>

            {onEditPrompts ? (
              <button
                type="button"
                className="btn btn-sm filters-drawer-btn-reset geo-card-action-btn page-header-edit-prompts"
                onClick={onEditPrompts}
              >
                Edit Prompts
              </button>
            ) : null}

            {hasFiltersApplied && (
              <button type="button" className="btn btn-sm btn-clear-filters" onClick={onClearFilters}>
                <X size={14} className="btn-clear-filters-icon" />
                <span>Clear Filters</span>
              </button>
            )}

            <div className="filter-btn-wrap">
              <button
                type="button"
                className={`btn btn-sm ${showTableFilters ? 'btn-primary' : ''} btn-filters`}
                onClick={onToggleFilters}
              >
                <Filter size={14} />
                <span>Filters</span>
                {hasFiltersApplied && (
                  <span
                    className="btn-filters-dot"
                    style={{ background: showTableFilters ? '#fff' : 'var(--c-black)' }}
                  />
                )}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
